import React, { useEffect, useState } from "react";
import Button from "./Button";
import {
  setActiveForm,
  setActiveTab,
} from "../../redux/Reducer/Admin/PartnerSlice";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  setDoctorById,
  setDoctorsAssociatedWithStore,
} from "../../redux/Reducer/Doctor/DoctorSlice";
import SearchSelectedOrders from "../Store/SearchSelectedOrders";

const getTabIcon = (name) => {
  const normName = (name || "").toLowerCase().trim();
  switch (normName) {
    case "products":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      );
    case "stock":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
        </svg>
      );
    case "drugs":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      );
    case "v table":
    case "vtable":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M3 14h18M9 4v16M15 4v16M4 4h16a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1z" />
        </svg>
      );
    case "requests":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      );
    case "listing":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
        </svg>
      );
    case "integration":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      );
    case "database":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
        </svg>
      );
    case "orders":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
      );
    case "profile":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      );
    case "analytics":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      );
    case "frequent":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
        </svg>
      );
    case "records":
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      );
    case "subscription":
      return (
        <svg className="w-4 h-4 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
        </svg>
      );
    default:
      return (
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
      );
  }
};

const Tabs = ({ tabs, prefix, title, defaultTab }) => {
  const initialIndex = React.useMemo(() => {
    if (!defaultTab || !tabs) return 0;
    const foundIdx = tabs.findIndex(
      (t) => t.name.toLowerCase() === defaultTab.toLowerCase()
    );
    return foundIdx >= 0 ? foundIdx : 0;
  }, [defaultTab, tabs]);

  const [activTab, setActivTab] = useState(initialIndex);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [activeTabName, setActiveTabName] = useState(
    tabs[initialIndex]?.name || tabs[0]?.name
  );
  const dispatch = useDispatch();

  const { activatedTab, activeForm } = useSelector(
    ({ formSwitcher }) => ({
      activatedTab: formSwitcher?.activeTab,
      activeForm: formSwitcher?.activeForm,
    }),
    shallowEqual
  );
  const searchedProduct = useSelector((state) => state?.product?.searchProduct);
  const role = useSelector((state) => state?.auth?.role);

  useEffect(() => {
    if (defaultTab && tabs) {
      const idx = tabs.findIndex(
        (t) => t.name.toLowerCase() === defaultTab.toLowerCase()
      );
      if (idx >= 0) {
        setActivTab(idx);
        setActiveTabName(tabs[idx].name);
      }
    }
  }, [defaultTab, tabs]);

  useEffect(() => {
    if (activatedTab?.name?.length > 0) {
      const foundIdx = tabs.findIndex(
        (t) => t?.name?.toLowerCase() === activatedTab.name.toLowerCase()
      );
      const targetIndex =
        foundIdx >= 0
          ? foundIdx
          : typeof activatedTab.index === "number"
          ? activatedTab.index
          : 0;
      setActiveTabName(tabs[targetIndex]?.name || activatedTab.name);
      setActivTab(targetIndex);
      dispatch(setActiveTab({ name: "", index: "" }));
    }
  }, [activatedTab, tabs, dispatch]);

  useEffect(() => {
    const handleTabChange = () => {
      setActivTab(activatedTab?.index);
      setActiveTabName(activatedTab?.name);
    };
    window.addEventListener("tabChangeEvent", handleTabChange);
    window.addEventListener("tabChangeEventStore", handleTabChange);
    return () => {
      window.removeEventListener("tabChangeEvent", handleTabChange);
      window.removeEventListener("tabChangeEventStore", handleTabChange);
    };
  }, [activatedTab, searchedProduct, dispatch]);

  const handleChangeTab = (tab, index) => {
    setActivTab(index);
    setActiveTabName(tab.name);
  };

  useEffect(() => {
    if (activeTabName === "Integration") {
      dispatch(setDoctorById({}));
      dispatch(setDoctorsAssociatedWithStore([]));
    }
  }, [activeTabName, dispatch]);

  return (
    <div className="w-full space-y-4">
      {/* Single-Line Header Bar */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 pb-3 border-b border-gray-200/80">
        {/* Left Side: SidebarToggle + Logo & Title + Partition + Segmented Tabs */}
        <div className="flex items-center gap-3 flex-wrap md:flex-nowrap min-w-0">
          {prefix && <div className="flex items-center shrink-0">{prefix}</div>}

          {title && (
            <div className="flex items-center gap-2.5 shrink-0">
              <div className="flex flex-col gap-0.5 shrink-0 justify-center">
                <div className="flex items-center gap-1.5 shrink-0">
                  <img src="/logo.png" alt="logo" className="h-[18px] sm:h-[20px] w-auto object-contain shrink-0" />
                  <img src="/logo.svg" alt="Hyperapt" className="h-[14px] sm:h-[16px] w-auto max-w-[85px] sm:max-w-[100px] object-contain shrink-0" />
                </div>
                <span className="text-[17px] sm:text-[20px] font-black text-gray-900 tracking-tight leading-none">
                  {title}
                </span>
              </div>

              {/* Partition Divider */}
              <div className="h-7 w-[1px] bg-gray-200 hidden sm:block mx-1 shrink-0" />
            </div>
          )}

          {/* Segmented Pill Tab Bar (In-line next to partition) */}
          <div className="bg-gray-100/90 p-1.5 rounded-2xl border border-gray-200/70 flex items-center gap-1.5 overflow-x-auto no-scrollbar scroll-smooth">
            {tabs?.map((tab, index) => {
              const isActive = activTab === index;
              return (
                <button
                  key={index}
                  type="button"
                  onClick={() => handleChangeTab(tab, index)}
                  className={`px-3.5 py-2 rounded-xl text-xs sm:text-sm font-semibold transition-all duration-200 flex items-center gap-2 whitespace-nowrap cursor-pointer select-none ${
                    isActive
                      ? "bg-white text-gray-900 shadow-xs border border-gray-200/90 font-extrabold"
                      : "text-gray-600 hover:text-gray-900 font-medium hover:bg-white/60"
                  }`}
                >
                  <span className={`transition-transform duration-200 ${isActive ? "scale-110" : "opacity-80"}`}>
                    {tab.icon || getTabIcon(tab?.name)}
                  </span>
                  <span>{tab?.name}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Right Side: Action Controls */}
        {activeTabName === "Listing" && (
          <div className="flex items-center justify-end shrink-0">
            <Button
              className="bg-primary-600 hover:bg-primary-700 h-[36px] text-white py-2 px-5 min-w-[120px] text-xs font-bold rounded-xl flex items-center justify-center gap-2 shadow-xs transition-all cursor-pointer"
              onClick={() => {
                if (!activeForm) {
                  dispatch(setActiveForm("doctor"));
                  dispatch(setDoctorById({}));
                } else {
                  dispatch(setActiveForm(null));
                }
              }}
            >
              {activeForm ? "Cancel" : "+ New"}
            </Button>
          </div>
        )}

        {activeTabName === "Records" && role === "store" && (
          <div className="flex items-center justify-end shrink-0">
            <SearchSelectedOrders
              selectedOrder={selectedOrder}
              setSelectedOrder={setSelectedOrder}
            />
          </div>
        )}
      </div>

      {/* Tab Content */}
      <div className="w-full transition-opacity duration-300">
        {tabs[activTab]?.content}
      </div>
    </div>
  );
};

export default Tabs;
